import React from "react";
import SingleHistogramChart from "./SingleHistogramChart";
import { translate } from "../../languages";
import { Loader } from "rsuite";


export default function MultiHistogramChart({ chartData, loading }) {

  const renderHistograms = () => {
    return chartData.map((seriesData, index) => (
      <div key={`hist-${seriesData.id || index}`} style={{ marginBottom: "2rem" }}>
        {seriesData.data.length > 1 && <SingleHistogramChart seriesData={seriesData} tags={chartData.map(tag => tag.id)} /> }
      </div>
    ));
  };

  const getLoadingBlur = () => {
    return (
      <div
        style={{
          backgroundColor: "rgba(242, 242, 242, 0.7)",
          position: "absolute",
          height: "100%",
          width: "100%",
          zIndex: "10"
        }}
      >
        <div className="d-flex align-items-center justify-content-center h-100">
          <Loader size="lg" />
          <span className="ms-3" style={{ fontSize: "2rem" }}>
            {translate("Loading data")}
          </span>
        </div>
      </div>
    );
  };

  return (
    <div style={{ position: "relative" }}>
      {loading && getLoadingBlur()}
      {chartData.length > 0
        ? renderHistograms()
        : <div>{translate("No data available")}</div>}
    </div>
  );
}
